import {Locales} from '@netx/core-next/locales/utils/Locales';

export const CurrentCartActionLabel = Locales((i18n) => ({
	DOCUMENTATION: i18n('i18n.documentation'),
	ROUTE: i18n('i18n.bulkCartLoader'),
	SUBMIT: i18n('i18n.save'),
}));

export const CurrentCartMessage = Locales((i18n) => ({
	HELP: i18n('i18n.uploadCartDocs'),
	PROCESSING: i18n('i18n.processingBulkCartLoaderData'),
	PROCESSED: i18n('i18n.bulkCartUploadSucceeded'),
	PROCESSING_FAILED: i18n('i18n.bulkCartUploadFailed'),
}));

export const CurrentCartTitle = Locales((i18n) => ({
	IMPORT: i18n('i18n.bulkCartLoader'),
}));
